function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { BaseTextField } from "./BaseTextField";
import { PasswordTextField } from "./PasswordTextField";
import { SearchTextField } from "./SearchTextField";
export const TextField = /*#__PURE__*/React.forwardRef((props, ref) => {
  let Component;
  switch (props.type) {
    case "password":
      Component = PasswordTextField;
      break;
    case "search":
      Component = SearchTextField;
      break;
    default:
      Component = BaseTextField;
      break;
  }
  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    ref: ref
  }));
});